// extracted by mini-css-extract-plugin
export default {"search":"press-secretaries_search__UyVet","field":"press-secretaries_field__GDXgd","list":"press-secretaries_list__WdYxC"};